
import slidersInit from "../components/sliders.js";
import scrollInit from "../components/scroll.js";
// import lightboxInit from "../components/lightbox.js";
import lightGalleryInit from "../components/lightgallery.js";
import productInit from "../components/product.js";

document.addEventListener("DOMContentLoaded", () => {

    // init Product Content Slider
    const { interiorSliderInit, productInteriorSliderInit } = slidersInit();
    const sliderInterior = interiorSliderInit();
    productInteriorSliderInit();

    // sticky navigation on scroll
    const { navScrollInit } = scrollInit();
    navScrollInit();

    const { addProductToShoppingCartHandle } = productInit();
    addProductToShoppingCartHandle();

    // init lightbox
    // const { lightboxWithButtonsInit } = lightboxInit();
    // lightboxWithButtonsInit('.interior__hero_slider_item', sliderInterior, '.interior__hero_slider', '.interior__hero_slider_button');

    // init lightGallery
    const { lightGalleryWithButtonsInit } = lightGalleryInit();
    lightGalleryWithButtonsInit();

});
